import { SELECIONAR_DISPONIBILIDADE_VEICULO } from '../types'

export default function selecionarDisponibilidadeVeiculo (disponibilidadesVeiculo) {
  return {
    type: SELECIONAR_DISPONIBILIDADE_VEICULO,
    payload: disponibilidadesVeiculo
  }
}
